export default {
  ERROR_GETTING_AVAILABLE_MANAGERS: "There was an error retrieving Available Managers",
  ERROR_CREATING_SALES_TEAM: "There was an error creating a Sales Team",
  ERROR_CREATING_TEAM_ASSIGNMENT: "There was an error creating a Team Assignment",
  SUCCESS_CREATING_SALES_TEAM: "Sales Team created",
  SUCCESS_CREATING_TEAM_ASSIGNMENT: "Team Assignment created",
};
